<template>
    <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
        <h3 id="tituloPainel" class="card-dados__titulo mb-0">Listagem</h3>

        <v-data-table :headers="headersTabela" :items="value" hide-actions
                      class="az-table-list tabela-itens">
            <template slot="items" slot-scope="props">
                <td>
                    {{ props.item.identificacaoSequencial }}
                </td>
                <td ref="coluna_descricao">
                    <expansao-texto :tamanho="tamanho" :texto="props.item.descricao"/>
                </td>
                <td>
                    <v-tooltip top v-if="props.item.motivo" class="botao-motivo">
                        <a slot="activator">
                            {{ props.item.situacao | azEnum(situacoesItensELotes) }}
                            <i class="fas fa-comment" aria-hidden="true"/>
                        </a>
                        {{ props.item.motivo }}
                    </v-tooltip>
                    <span v-else>
                        {{ props.item.situacao | azEnum(situacoesItensELotes) }}
                    </span>
                </td>
                <td>
                    {{ props.item.porteExclusivo ? 'Sim' : 'Não' }}
                </td>
                <td align="right">
                    {{ props.item.unidade }}
                </td>
                <td align="right">
                    {{ props.item.quantidade | cdCurrency('', qtdeCasasDecimais(casasDecimaisQuantidade)) }}
                </td>
                <td v-if="possuiValorReferencia && exibirValorDeReferencia" align="right">
                    {{ props.item.valorEstimado | cdCurrency(prefix, casasDecimais) }}{{suffix}}
                </td>
            </template>
        </v-data-table>

        <div class="total total-mobile" v-if="!isCriterioJulgamentoMaiorDesconto && (value.length > 1 && possuiValorReferencia && exibirValorDeReferencia)">
            <p>
                <strong>Total:</strong> {{ total | cdCurrency(prefix, casasDecimais) }}{{suffix}}
            </p>
        </div>
    </v-flex>
</template>

<script>
import {situacoesItensELotes} from '@/core/constants'
import {mapState} from 'vuex'

export default {
    name: 'PainelItemVisualizacao',
    props: {
        value: {
            required: true,
            type: Array,
            default: () => {
                return []
            }
        },
        possuiValorReferencia: {
            type: Boolean,
        },
        exibirValorDeReferencia: {},
        casasDecimais: {
            type: Number,
            default: 2
        },
        prefixSuffixValor:{
            type: String
        },
        criterioJulgamento:{
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        casasDecimaisQuantidade:{
            type: Number,
            default: 2
        }
    },
    data() {
        return {
            tamanho: null,
            situacoesItensELotes
        }
    },
    computed: {
        ...mapState(['loki']),
        headersTabela(){
            return [
                {
                    sortable: true,
                    text: 'Seq',
                    align: 'left',
                    width: '5%',
                    class: 'primary--text',
                    value: 'sequencia'
                },
                {
                    value: 'descricao',
                    align: 'left',
                    text: 'Descrição',
                    width: '35%',
                    class: 'primary--text',
                    sortable: false
                },
                {
                    text: 'Situação',
                    value: 'situacao',
                    sortable: false,
                    align: 'left',
                    width: '15%',
                    class: 'primary--text'
                },
                {
                    text: 'Exclusivo',
                    sortable: false,
                    width: '5%',
                    align: 'left',
                    class: 'primary--text'
                },
                {
                    text: 'Unidade',
                    value: 'unidade',
                    sortable: false,
                    align: 'right',
                    width: '15%',
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    value: 'quantidade',
                    text: 'Quantidade',
                    align: 'right',
                    width: '15%',
                    class: 'primary--text'
                },
                ... this.possuiValorReferencia && this.exibirValorDeReferencia ? [{
                    text: this.criterioJulgamento === 'MENOR_PRECO' ? 'Valor Ref. Un.' : 'Ref. Unit.',
                    sortable: false,
                    align: 'right',
                    value: 'valorEstimado',
                    width: '10%',
                    class: 'primary--text'
                }] : [],
            ]
        },
        total() {
            let total = 0
            this.value.forEach(item => {
                total += item.valorEstimado
            })
            return total
        },
        prefix(){
            return this.prefixSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixSuffixValor === '%' ? '%' : ''
        },
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    },
    methods: {
        pegarTamanho() {
            this.tamanho = .082 * window.innerWidth
        }
    }
}
</script>

<style scoped lang="stylus">
    .tabela-itens
        padding 16px

    @media (max-width 720px)
        .tabela-itens
            padding 0

            td:nth-of-type(1):before
                content "Sequência:"

            td:nth-of-type(2):before
                content "Descrição:"

            td:nth-of-type(3):before
                content "Situação:"

            td:nth-of-type(4):before
                content "Exclusivo:"

            td:nth-of-type(5):before
                content "Unidade:"

            td:nth-of-type(6):before
                content "Quantidade:"

            td:nth-of-type(7):before
                content "Valor Ref. Un.:"

            td:nth-of-type(5)
                text-align left

            td:nth-of-type(6)
                text-align left

            td:nth-of-type(7)
                text-align left
</style>
